import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';

// ============================================================================
// ÍCONES SYSTEM
// ============================================================================
const Icons = {
  Tag: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>,
  Save: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>,
  Plus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
  CheckDouble: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#53bdeb' }}><path d="M2 12l5 5L20 4"></path><path d="M2 12l5 5L20 4"></path></svg>,
  Menu: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>,
  Close: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  Megaphone: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 19 2 12 11 5 11 19"></polygon><path d="M22 12c0-4.42-3.58-8-8-8v16c4.42 0 8-3.58 8-8z"></path></svg>,
  Users: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
  MessageCircle: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>,
  Handshake: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2"></path><path d="M20 12l-6-6-6 6"></path></svg>,
  Filter: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>,
  Send: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>,
  ArrowLeft: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>,
  Upload: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>,
  Trash: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>,
  Database: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"></path><path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"></path></svg>,
  FileUp: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M12 18v-6"></path><path d="m9 15 3-3 3 3"></path></svg>,
  Refresh: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
};

const defaultWelcomeConfig = {
  usarImagem: true,
  imagemUrl: '',
  mensagem: '*Obrigado pela sua compra nas Óticas Vizum!*\n\nAcabamos de concluir a entrega dos seus óculos — e ficaram realmente incríveis em você! 😍\n\nQualquer ajuste, dúvida ou necessidade, pode chamar a gente aqui mesmo.\nEstamos à disposição para garantir que sua nova visão seja a melhor possível.\n\nCom carinho,\n*Equipe Óticas Vizum*'
};

const defaultCampaignForm = {
  _id: null,
  titulo: '',
  mensagem: '',
  usarImagem: false,
  imagemUrl: '',
  statusCampanha: 'RASCUNHO',
  tipoCampanha: 'CLIENTES_MES',
  modoAniversario: 'MES'
};

const birthdayMonthTemplate = '*Parabéns pelo seu mês, {{nome}}!* 🎉🥳\n\nPreparamos uma condição especial de aniversariante pra você renovar sua armação com a gente neste mês.\n\nSe quiser, te mostro as opções aqui mesmo.';
const birthdayTodayTemplate = '*Hoje é o seu dia, {{nome}}!* 🎂🎉\n\nPassando pra te desejar um feliz aniversário e te liberar uma condição especial pra você aproveitar hoje com a gente.\n\nSe quiser, te mostro as opções agora mesmo.';

export default function TemplatesManager() {
  const [activeModule, setActiveModule] = useState('pos-venda');
  const [notification, setNotification] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const posVendaFileInputRef = useRef(null);
  const welcomeFileInputRef = useRef(null);
  const campaignFileInputRef = useRef(null);
  const importBaseFileInputRef = useRef(null);

  // Pós-venda
  const [templates, setTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({ marco: '', titulo: '', mensagem: '', usarImagem: false, imagemUrl: '' });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploadingPosVendaImage, setUploadingPosVendaImage] = useState(false);

  // Boas-vindas
  const [welcomeConfig, setWelcomeConfig] = useState(defaultWelcomeConfig);
  const [savingWelcome, setSavingWelcome] = useState(false);
  const [uploadingWelcomeImage, setUploadingWelcomeImage] = useState(false);

  // Campanhas
  const [campaignView, setCampaignView] = useState('list');
  const [campaignsList, setCampaignsList] = useState([]);
  const [loadingCampaigns, setLoadingCampaigns] = useState(false);
  const [campaignForm, setCampaignForm] = useState(defaultCampaignForm);

  const hoje = new Date();
  const mesAtual = String(hoje.getMonth() + 1).padStart(2, '0') + '/' + hoje.getFullYear();

  const [campaignMonth, setCampaignMonth] = useState(mesAtual);
  const [clientsData, setClientsData] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [savingCampaignDraft, setSavingCampaignDraft] = useState(false);
  const [sendingCampaign, setSendingCampaign] = useState(false);
  const [loadingClients, setLoadingClients] = useState(false);
  const [uploadingCampaignImage, setUploadingCampaignImage] = useState(false);

  // Base externa
  const [importedBaseList, setImportedBaseList] = useState([]);
  const [loadingImportedBase, setLoadingImportedBase] = useState(false);
  const [importingBaseFile, setImportingBaseFile] = useState(false);
  const [lastImportSummary, setLastImportSummary] = useState(null);

  const isBirthdayCampaign = campaignForm.tipoCampanha === 'ANIVERSARIANTES';
  const isBirthdayTodayMode = isBirthdayCampaign && campaignForm.modoAniversario === 'HOJE';
  const isBirthdayMonthMode = isBirthdayCampaign && campaignForm.modoAniversario === 'MES';

  const campaignTargetLabel = !isBirthdayCampaign
    ? 'Clientes do mês'
    : isBirthdayTodayMode
      ? 'Aniversariantes de hoje'
      : 'Aniversariantes do mês';

  const campaignFilterLabel = !isBirthdayCampaign
    ? 'Filtrar vendas de:'
    : isBirthdayTodayMode
      ? 'Base do mês para aniversariantes de hoje:'
      : 'Filtrar aniversariantes de:';

  const campaignDateColumnLabel = isBirthdayCampaign ? 'Aniversário' : 'Data da Compra';

  const campaignEmptyStateLabel = !isBirthdayCampaign
    ? 'Nenhum cliente com WhatsApp encontrado neste mês.'
    : isBirthdayTodayMode
      ? 'Nenhum cliente faz aniversário hoje.'
      : 'Nenhum aniversariante com WhatsApp encontrado neste mês.';

  useEffect(() => {
    fetchTemplates();
    loadWelcomeConfig();
  }, []);

  useEffect(() => {
    if (activeModule === 'campanhas' && campaignView === 'list') {
      fetchCampaignsList();
    }
  }, [activeModule, campaignView]);

  useEffect(() => {
    if (activeModule === 'campanhas' && campaignView === 'editor') {
      fetchCampaignAudience();
    }
  }, [campaignMonth, campaignView, campaignForm.tipoCampanha, campaignForm.modoAniversario]);

  useEffect(() => {
    if (activeModule === 'base-externa') {
      fetchImportedBase();
    }
  }, [activeModule]);

  useEffect(() => {
    if (selectedId && selectedId !== 'NEW') {
      const temp = templates.find((t) => t._id === selectedId);
      if (temp) {
        setFormData({
          marco: temp.marco,
          titulo: temp.titulo,
          mensagem: temp.mensagem,
          usarImagem: temp.usarImagem || false,
          imagemUrl: temp.imagemUrl || ''
        });
      }
    }
  }, [selectedId, templates]);

  const showNotify = (msg, type) => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3500);
  };

  const insertTag = (editorId, stateObj, setStateFn) => {
    const textarea = document.getElementById(editorId);
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = stateObj.mensagem;
    setStateFn({ ...stateObj, mensagem: text.substring(0, start) + '{{nome}}' + text.substring(end) });
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + 8, start + 8);
    }, 10);
  };

  const getFullImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    const baseUrl = api.defaults.baseURL || '';
    return `${baseUrl}${url}`;
  };

  // APIs base
  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/templates');
      const sorted = (Array.isArray(res.data) ? res.data : []).sort((a, b) => a.marco - b.marco);
      setTemplates(sorted);
      if (sorted.length > 0 && selectedId !== 'NEW' && !selectedId) setSelectedId(sorted[0]._id);
    } catch {
      showNotify('Erro ao carregar templates.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleNewTemplate = () => {
    setSelectedId('NEW');
    setFormData({ marco: '', titulo: '', mensagem: '', usarImagem: false, imagemUrl: '' });
  };

  const handleSavePosVenda = async () => {
    setSaving(true);
    try {
      await api.post('/api/templates', formData);
      showNotify('Template salvo!', 'success');
      await fetchTemplates();
    } catch {
      showNotify('Erro ao salvar.', 'error');
    } finally {
      setSaving(false);
    }
  };

  const loadWelcomeConfig = async () => {
    try {
      const res = await api.get('/ordens-servico/config/boas-vindas');
      setWelcomeConfig({ ...defaultWelcomeConfig, ...(res?.data || {}) });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveWelcomeConfig = async () => {
    setSavingWelcome(true);
    try {
      await api.post('/ordens-servico/config/boas-vindas', { ...welcomeConfig, ativo: true });
      showNotify('Boas-vindas salvas!', 'success');
    } catch {
      showNotify('Erro ao salvar.', 'error');
    } finally {
      setSavingWelcome(false);
    }
  };

  // Uploads
  const handleUploadPosVendaImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append('imagem', file);

    setUploadingPosVendaImage(true);
    try {
      const res = await api.post('/ordens-servico/api/templates/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setFormData(prev => ({ ...prev, imagemUrl: res.data.imageUrl }));
      showNotify('Imagem anexada à régua!', 'success');
    } catch {
      showNotify('Erro ao fazer upload da imagem.', 'error');
    } finally {
      setUploadingPosVendaImage(false);
      if (posVendaFileInputRef.current) posVendaFileInputRef.current.value = null;
    }
  };

  const handleUploadWelcomeImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append('imagem', file);

    setUploadingWelcomeImage(true);
    try {
      const res = await api.post('/ordens-servico/config/boas-vindas/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setWelcomeConfig(prev => ({ ...prev, imagemUrl: res.data.imageUrl }));
      showNotify('Imagem de boas-vindas anexada!', 'success');
    } catch {
      showNotify('Erro ao fazer upload da imagem.', 'error');
    } finally {
      setUploadingWelcomeImage(false);
      if (welcomeFileInputRef.current) welcomeFileInputRef.current.value = null;
    }
  };

  const handleUploadCampaignImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append('imagem', file);

    setUploadingCampaignImage(true);
    try {
      const res = await api.post('/ordens-servico/api/campanhas/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setCampaignForm(prev => ({ ...prev, imagemUrl: res.data.imageUrl }));
      showNotify('Flyer da campanha anexado!', 'success');
    } catch {
      showNotify('Erro ao fazer upload da imagem.', 'error');
    } finally {
      setUploadingCampaignImage(false);
      if (campaignFileInputRef.current) campaignFileInputRef.current.value = null;
    }
  };

  const handleImportBaseFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const form = new FormData();
    form.append('arquivo', file);

    setImportingBaseFile(true);
    try {
      const res = await api.post('/ordens-servico/api/base-campanhas/importar', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setLastImportSummary(res.data || null);
      showNotify('Base importada com sucesso!', 'success');
      await fetchImportedBase();
    } catch (error) {
      showNotify(error?.response?.data?.error || 'Erro ao importar arquivo.', 'error');
    } finally {
      setImportingBaseFile(false);
      if (importBaseFileInputRef.current) importBaseFileInputRef.current.value = null;
    }
  };

  const fetchImportedBase = async () => {
    setLoadingImportedBase(true);
    try {
      const res = await api.get('/ordens-servico/api/base-campanhas');
      setImportedBaseList(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error(error);
      showNotify('Erro ao carregar base externa.', 'error');
    } finally {
      setLoadingImportedBase(false);
    }
  };

  const handleRemoveImportedContact = async (id) => {
    if (!window.confirm('Deseja remover este contato importado?')) return;

    try {
      await api.delete(`/ordens-servico/api/base-campanhas/${id}`);
      showNotify('Contato removido com sucesso!', 'success');
      await fetchImportedBase();
    } catch (error) {
      showNotify('Erro ao remover contato.', 'error');
    }
  };

  // Campanhas
  const fetchCampaignsList = async () => {
    setLoadingCampaigns(true);
    try {
      const res = await api.get('/ordens-servico/api/campanhas');
      setCampaignsList(res.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCampaigns(false);
    }
  };

  const fetchCampaignAudience = async () => {
    setLoadingClients(true);
    try {
      let endpoint = `/ordens-servico/api/campanhas/clientes?mesFiltro=${campaignMonth}`;

      if (isBirthdayCampaign) {
        endpoint = `/ordens-servico/api/campanhas/aniversariantes?mesFiltro=${campaignMonth}&modo=${campaignForm.modoAniversario || 'MES'}`;
      }

      const res = await api.get(endpoint);
      const audience = Array.isArray(res.data) ? res.data : [];
      setClientsData(audience);

      if (!campaignForm._id) {
        setSelectedClients(audience.map(c => c.id));
      }
    } catch {
      showNotify(
        isBirthdayCampaign ? 'Erro ao buscar aniversariantes.' : 'Erro ao buscar clientes.',
        'error'
      );
    } finally {
      setLoadingClients(false);
    }
  };

  const handleToggleClient = (id) => {
    setSelectedClients(prev =>
      prev.includes(id) ? prev.filter(cId => cId !== id) : [...prev, id]
    );
  };

  const handleToggleAll = () => {
    setSelectedClients(
      selectedClients.length === clientsData.length ? [] : clientsData.map(c => c.id)
    );
  };

  const handleNewCampaign = (tipoCampanha = 'CLIENTES_MES') => {
    const isBirthday = tipoCampanha === 'ANIVERSARIANTES';

    setCampaignForm({
      ...defaultCampaignForm,
      tipoCampanha,
      modoAniversario: 'MES',
      titulo: isBirthday ? 'Campanha de Aniversariantes do Mês' : '',
      mensagem: isBirthday ? birthdayMonthTemplate : ''
    });

    setCampaignMonth(mesAtual);
    setSelectedClients([]);
    setCampaignView('editor');
  };

  const handleEditCampaign = (campanha) => {
    setCampaignForm({
      _id: campanha._id,
      titulo: campanha.titulo,
      mensagem: campanha.mensagem,
      usarImagem: campanha.usarImagem,
      imagemUrl: campanha.imagemUrl,
      statusCampanha: campanha.statusCampanha,
      tipoCampanha: campanha.tipoCampanha || 'CLIENTES_MES',
      modoAniversario: campanha.modoAniversario || 'MES'
    });
    setCampaignMonth(campanha.mesFiltro);
    setSelectedClients(campanha.clientesSelecionados?.map(c => c.clienteId) || []);
    setCampaignView('editor');
  };

  const handleChangeBirthdayMode = (modo) => {
    setCampaignForm(prev => ({
      ...prev,
      modoAniversario: modo,
      titulo:
        modo === 'HOJE'
          ? (prev._id ? prev.titulo : 'Campanha de Aniversariantes de Hoje')
          : (prev._id ? prev.titulo : 'Campanha de Aniversariantes do Mês'),
      mensagem:
        modo === 'HOJE'
          ? (prev._id ? prev.mensagem : birthdayTodayTemplate)
          : (prev._id ? prev.mensagem : birthdayMonthTemplate)
    }));
    setSelectedClients([]);
  };

  const handleSaveCampaignDraft = async () => {
    if (!campaignForm.titulo) {
      showNotify('Dê um nome para a campanha.', 'error');
      return;
    }

    setSavingCampaignDraft(true);
    try {
      const payload = {
        ...campaignForm,
        tipoCampanha: campaignForm.tipoCampanha || 'CLIENTES_MES',
        modoAniversario: campaignForm.modoAniversario || 'MES',
        mesFiltro: campaignMonth,
        clientesSelecionados: clientsData
          .filter(c => selectedClients.includes(c.id))
          .map(c => ({
            clienteId: c.id,
            nome: c.nome,
            telefone: c.telefone
          }))
      };

      if (campaignForm._id) {
        await api.put(`/ordens-servico/api/campanhas/${campaignForm._id}`, payload);
      } else {
        const res = await api.post('/ordens-servico/api/campanhas', payload);
        setCampaignForm(prev => ({ ...prev, _id: res.data._id }));
      }

      showNotify('Campanha salva com sucesso!', 'success');
      setCampaignView('list');
    } catch {
      showNotify('Erro ao salvar rascunho.', 'error');
    } finally {
      setSavingCampaignDraft(false);
    }
  };

  const handleSendCampaign = async () => {
    if (selectedClients.length === 0) {
      showNotify('Selecione pelo menos um cliente.', 'error');
      return;
    }

    if (!campaignForm.mensagem) {
      showNotify('A mensagem não pode estar vazia.', 'error');
      return;
    }

    if (!window.confirm(`Tem certeza que deseja iniciar o disparo para ${selectedClients.length} clientes?`)) return;

    setSendingCampaign(true);
    try {
      const clientesParaEnvio = clientsData.filter(c => selectedClients.includes(c.id));

      const payload = {
        _id: campaignForm._id,
        titulo: campaignForm.titulo,
        mensagem: campaignForm.mensagem,
        usarImagem: campaignForm.usarImagem,
        imagemUrl: campaignForm.imagemUrl,
        tipoCampanha: campaignForm.tipoCampanha || 'CLIENTES_MES',
        modoAniversario: campaignForm.modoAniversario || 'MES',
        mesFiltro: campaignMonth,
        clientes: clientesParaEnvio
      };

      await api.post('/ordens-servico/api/campanhas/enviar', payload);
      showNotify(`Disparo iniciado para ${selectedClients.length} contatos!`, 'success');
      setCampaignView('list');
    } catch {
      showNotify('Erro ao solicitar disparo.', 'error');
    } finally {
      setSendingCampaign(false);
    }
  };

  const gerarOpcoesMeses = () => {
    const opcoes = [];
    const hojeLocal = new Date();

    for (let i = 0; i < 24; i++) {
      const data = new Date(hojeLocal.getFullYear(), hojeLocal.getMonth() - i, 1);
      const value = `${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;
      const nomeMes = data.toLocaleString('pt-BR', { month: 'long' });
      opcoes.push(
        <option key={value} value={value}>
          {`${nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1)} / ${data.getFullYear()}`}
        </option>
      );
    }

    return opcoes;
  };

  const renderPreviewText = (text) => {
    if (!text) return <span className="placeholder-text">Sua mensagem aparecerá aqui...</span>;

    return text.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line.split(/(\*.*?\*|_.*?_|~.*?~|{{nome}})/gi).map((part, j) => {
          if (part.startsWith('*') && part.endsWith('*')) return <strong key={j}>{part.slice(1, -1)}</strong>;
          if (part.startsWith('_') && part.endsWith('_')) return <em key={j}>{part.slice(1, -1)}</em>;
          if (part.startsWith('~') && part.endsWith('~')) return <del key={j}>{part.slice(1, -1)}</del>;
          if (part.toLowerCase() === '{{nome}}') return <span key={j} className="var-highlight">João Silva</span>;
          return part;
        })}
        <br />
      </React.Fragment>
    ));
  };

  const renderPhoneMockup = (configObj) => (
    <div className="preview-card-shell">
      <div className="preview-title-row">
        <span className="preview-kicker">PREVIEW</span>
        <span className="preview-badge">Tempo real</span>
      </div>
      <div className="phone-mockup">
        <div className="phone-notch"></div>
        <div className="phone-header">
          <div className="ph-avatar">VIZ</div>
          <div className="ph-info">
            <span className="ph-name">Óticas Vizum</span>
            <span className="ph-status">Conta comercial</span>
          </div>
        </div>
        <div className="phone-body">
          <div className="msg-bubble incoming">
            {configObj.usarImagem && configObj.imagemUrl && (
              <div className="msg-image-preview">
                <img
                  src={getFullImageUrl(configObj.imagemUrl)}
                  alt="Anexo"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              </div>
            )}
            {renderPreviewText(configObj.mensagem)}
            <div className="msg-meta">
              <span className="msg-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
              <span className="msg-check"><Icons.CheckDouble /></span>
            </div>
          </div>
        </div>
        <div className="phone-footer">
          <div className="ph-input">Mensagem</div>
          <div className="ph-mic">🎤</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="cms-container animate-fade-in">
      <div className="cms-header">
        <div className="header-info">
          <div className="brand-badge">VIZUM ENGINE v3.0</div>
          <h2>Gestor de Comunicação</h2>
        </div>
        <div className="header-actions">
          {notification && (
            <div className={`notify-pill ${notification.type}`}>
              {notification.type === 'success' ? '✓' : '✕'} {notification.msg}
            </div>
          )}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="btn-icon mobile-only">
            {mobileMenuOpen ? <Icons.Close /> : <Icons.Menu />}
          </button>
        </div>
      </div>

      <div className="cms-body">
        <aside className={`main-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="nav-group">
            <span className="nav-label">Automações</span>
            <button className={`nav-item ${activeModule === 'pos-venda' ? 'active' : ''}`} onClick={() => { setActiveModule('pos-venda'); setMobileMenuOpen(false); }}>
              <Icons.MessageCircle /> Régua Pós-Venda
            </button>
            <button className={`nav-item ${activeModule === 'boas-vindas' ? 'active' : ''}`} onClick={() => { setActiveModule('boas-vindas'); setMobileMenuOpen(false); }}>
              <Icons.Handshake /> Boas-Vindas
            </button>
          </div>

          <div className="nav-group">
            <span className="nav-label">Marketing</span>
            <button className={`nav-item ${activeModule === 'campanhas' ? 'active' : ''}`} onClick={() => { setActiveModule('campanhas'); setCampaignView('list'); setMobileMenuOpen(false); }}>
              <Icons.Megaphone /> Campanhas <span className="badge-new">Novo</span>
            </button>
          </div>

          <div className="nav-group">
            <span className="nav-label">Dados</span>
            <button className={`nav-item ${activeModule === 'base-externa' ? 'active' : ''}`} onClick={() => { setActiveModule('base-externa'); setMobileMenuOpen(false); }}>
              <Icons.Database /> Base Externa
            </button>
          </div>
        </aside>

        <div className="cms-workspace">
          {activeModule === 'pos-venda' && (
            <div className="workspace-grid-with-sidebar">
              <aside className="secondary-sidebar">
                <div className="sidebar-header-row">
                  <div className="sidebar-title">GATILHOS ATIVOS</div>
                  <button className="btn-new-mini" onClick={handleNewTemplate}><Icons.Plus /> Novo</button>
                </div>

                <div className="template-list">
                  {selectedId === 'NEW' && (
                    <div className="template-item active">
                      <div className="item-icon">✨</div>
                      <div className="item-content"><span className="item-marco">Novo Gatilho</span></div>
                    </div>
                  )}

                  {loading ? (
                    <div className="loading-txt">Carregando...</div>
                  ) : (
                    templates.map((t) => (
                      <div key={t._id} className={`template-item ${selectedId === t._id ? 'active' : ''}`} onClick={() => setSelectedId(t._id)}>
                        <div className="item-icon">{t.marco === '0' ? '🚀' : t.marco === '7d' ? '👓' : '📅'}</div>
                        <div className="item-content">
                          <span className="item-marco">{t.marco === '7d' ? '7 Dias' : t.marco === '0' ? 'Entrega' : `Mês ${t.marco}`}</span>
                          <span className="item-title">{t.titulo}</span>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </aside>

              {selectedId ? (
                <div className="workspace-content-split">
                  <div className="editor-panel">
                    <div className="editor-form">
                      <h3>Configuração do Gatilho</h3>

                      <div className="form-row">
                        <div className="input-group flex-1">
                          <label>Nome do Gatilho (Interno)</label>
                          <input type="text" value={formData.titulo} onChange={(e) => setFormData({ ...formData, titulo: e.target.value })} />
                        </div>

                        <div className="input-group w-120">
                          <label>Marco (Chave)</label>
                          {selectedId === 'NEW' ? (
                            <input type="text" value={formData.marco} onChange={(e) => setFormData({ ...formData, marco: e.target.value })} placeholder="Ex: 7d, 1" />
                          ) : (
                            <div className="locked-badge">🔒 {formData.marco}</div>
                          )}
                        </div>
                      </div>

                      <div className="image-config-box">
                        <div className="switch-row compact">
                          <div>
                            <strong>Anexar Imagem</strong>
                            <span>Enviar foto junto ao texto deste mês</span>
                          </div>
                          <label className="switch">
                            <input type="checkbox" checked={formData.usarImagem} onChange={(e) => setFormData({ ...formData, usarImagem: e.target.checked })} />
                            <span className="slider"></span>
                          </label>
                        </div>

                        {formData.usarImagem && (
                          <div className="upload-area mt-10">
                            <input type="file" accept="image/*" ref={posVendaFileInputRef} onChange={handleUploadPosVendaImage} style={{ display: 'none' }} />
                            {formData.imagemUrl ? (
                              <div className="uploaded-image-card">
                                <img src={getFullImageUrl(formData.imagemUrl)} alt="Preview Régua" />
                                <div className="uploaded-image-overlay">
                                  <button className="btn-remove-image" onClick={() => setFormData({ ...formData, imagemUrl: '' })}>
                                    <Icons.Trash /> Remover
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <button className="btn-upload-box" onClick={() => posVendaFileInputRef.current.click()} disabled={uploadingPosVendaImage}>
                                {uploadingPosVendaImage ? 'Enviando...' : <><Icons.Upload /><span>Selecionar imagem</span></>}
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="input-group flex-1 editor-block">
                        <div className="textarea-header">
                          <label>Script da Mensagem</label>
                          <button className="tag-btn" onClick={() => insertTag('posvenda-msg', formData, setFormData)} type="button">
                            <Icons.Tag /> <strong>{'{{nome}}'}</strong>
                          </button>
                        </div>

                        <textarea id="posvenda-msg" value={formData.mensagem} onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })} />

                        <div className="editor-footer">
                          <span className="char-count">{formData.mensagem.length} caracteres</span>
                          <button className="btn-save" onClick={handleSavePosVenda} disabled={saving}>
                            {saving ? 'Salvando...' : <><Icons.Save /> Salvar Gatilho</>}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="preview-panel">{renderPhoneMockup(formData)}</div>
                </div>
              ) : (
                <div className="empty-state"><div className="empty-illustration">📬</div><p>Selecione um template na lista</p></div>
              )}
            </div>
          )}

          {activeModule === 'boas-vindas' && (
            <div className="workspace-content-split module-fade">
              <div className="editor-panel">
                <div className="editor-form max-w-700">
                  <div className="module-header">
                    <h3>Mensagem de Boas-Vindas</h3>
                    <p>Disparada automaticamente no fechamento da OS / Entrega.</p>
                  </div>

                  <div className="image-config-box">
                    <div className="switch-row compact">
                      <div>
                        <strong>Anexar Imagem</strong>
                        <span>Enviar foto de agradecimento</span>
                      </div>
                      <label className="switch">
                        <input type="checkbox" checked={welcomeConfig.usarImagem} onChange={(e) => setWelcomeConfig({ ...welcomeConfig, usarImagem: e.target.checked })} />
                        <span className="slider"></span>
                      </label>
                    </div>

                    {welcomeConfig.usarImagem && (
                      <div className="upload-area mt-10">
                        <input type="file" accept="image/*" ref={welcomeFileInputRef} onChange={handleUploadWelcomeImage} style={{ display: 'none' }} />
                        {welcomeConfig.imagemUrl ? (
                          <div className="uploaded-image-card">
                            <img src={getFullImageUrl(welcomeConfig.imagemUrl)} alt="Preview Boas-Vindas" />
                            <div className="uploaded-image-overlay">
                              <button className="btn-remove-image" onClick={() => setWelcomeConfig({ ...welcomeConfig, imagemUrl: '' })}>
                                <Icons.Trash /> Remover
                              </button>
                            </div>
                          </div>
                        ) : (
                          <button className="btn-upload-box" onClick={() => welcomeFileInputRef.current.click()} disabled={uploadingWelcomeImage}>
                            {uploadingWelcomeImage ? 'Enviando...' : <><Icons.Upload /><span>Selecionar imagem</span></>}
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="input-group flex-1 editor-block mt-20">
                    <div className="textarea-header">
                      <label>Script da Mensagem</label>
                      <button className="tag-btn" onClick={() => insertTag('welcome-msg', welcomeConfig, setWelcomeConfig)} type="button">
                        <Icons.Tag /> <strong>{'{{nome}}'}</strong>
                      </button>
                    </div>

                    <textarea id="welcome-msg" className="welcome-textarea" value={welcomeConfig.mensagem} onChange={(e) => setWelcomeConfig({ ...welcomeConfig, mensagem: e.target.value })} />

                    <div className="editor-footer">
                      <span className="char-count">{welcomeConfig.mensagem.length} caracteres</span>
                      <button className="btn-save" onClick={handleSaveWelcomeConfig} disabled={savingWelcome}>
                        {savingWelcome ? 'Salvando...' : <><Icons.Save /> Salvar Boas-Vindas</>}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="preview-panel">{renderPhoneMockup(welcomeConfig)}</div>
            </div>
          )}

          {activeModule === 'campanhas' && (
            <div className="campaign-workspace module-fade">
              {campaignView === 'list' && (
                <div className="campaign-list-view">
                  <div className="campaign-header-row">
                    <div>
                      <h3>Minhas Campanhas</h3>
                      <p>Gerencie seus disparos em lote para clientes antigos e base externa.</p>
                    </div>

                    <div className="campaign-header-actions">
                      <button className="btn-new-secondary" onClick={() => handleNewCampaign('ANIVERSARIANTES')}>
                        <Icons.Users /> Criar Campanha de Aniversariantes
                      </button>
                      <button className="btn-new-big" onClick={() => handleNewCampaign('CLIENTES_MES')}>
                        <Icons.Plus /> Criar Nova Campanha
                      </button>
                    </div>
                  </div>

                  <div className="campaigns-grid-cards">
                    {loadingCampaigns ? (
                      <div className="loading-txt">Carregando campanhas...</div>
                    ) : campaignsList.length === 0 ? (
                      <div className="empty-state">
                        <div className="empty-illustration">📢</div>
                        <p>Nenhuma campanha criada ainda.</p>
                      </div>
                    ) : (
                      campaignsList.map((camp) => (
                        <div key={camp._id} className="campaign-card" onClick={() => handleEditCampaign(camp)}>
                          <div className="camp-card-header">
                            <span className={`status-badge ${camp.statusCampanha.toLowerCase()}`}>{camp.statusCampanha}</span>
                            <span className="camp-date">{camp.mesFiltro}</span>
                          </div>

                          <div className="campaign-card-type">
                            {camp.tipoCampanha === 'ANIVERSARIANTES'
                              ? `🎂 ${camp.modoAniversario === 'HOJE' ? 'Aniversário de Hoje' : 'Aniversariantes do Mês'}`
                              : '📣 Campanha Geral'}
                          </div>

                          <h4>{camp.titulo || 'Campanha sem título'}</h4>

                          <div className="camp-stats">
                            <div><strong>{camp.totalSelecionados || 0}</strong> Clientes</div>
                            <div><strong>{camp.totalEnviados || 0}</strong> Enviados</div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}

              {campaignView === 'editor' && (
                <>
                  <div className="campaign-header">
                    <button className="btn-back" onClick={() => setCampaignView('list')}>
                      <Icons.ArrowLeft /> Voltar
                    </button>
                    <div>
                      <h3>
                        {campaignForm._id
                          ? `Editar ${isBirthdayCampaign ? 'Campanha de Aniversário' : 'Campanha'}`
                          : `Criador de ${isBirthdayCampaign ? 'Campanha de Aniversário' : 'Campanha'}`}
                      </h3>
                      <span className={`status-badge inline ${campaignForm.statusCampanha.toLowerCase()}`}>
                        {campaignForm.statusCampanha}
                      </span>
                    </div>
                  </div>

                  <div className="campaign-type-strip">
                    <button
                      className={`type-chip ${!isBirthdayCampaign ? 'active' : ''}`}
                      onClick={() =>
                        setCampaignForm(prev => ({
                          ...prev,
                          tipoCampanha: 'CLIENTES_MES',
                          titulo: prev._id ? prev.titulo : '',
                          mensagem: prev._id ? prev.mensagem : '',
                          modoAniversario: 'MES'
                        }))
                      }
                      type="button"
                    >
                      📣 Clientes do mês
                    </button>

                    <button
                      className={`type-chip ${isBirthdayCampaign ? 'active' : ''}`}
                      onClick={() =>
                        setCampaignForm(prev => ({
                          ...prev,
                          tipoCampanha: 'ANIVERSARIANTES',
                          modoAniversario: prev.modoAniversario || 'MES',
                          titulo: prev._id ? prev.titulo : 'Campanha de Aniversariantes do Mês',
                          mensagem: prev._id ? prev.mensagem : birthdayMonthTemplate
                        }))
                      }
                      type="button"
                    >
                      🎂 Aniversariantes
                    </button>
                  </div>

                  {isBirthdayCampaign && (
                    <div className="birthday-mode-strip">
                      <button
                        className={`type-chip ${isBirthdayMonthMode ? 'active' : ''}`}
                        onClick={() => handleChangeBirthdayMode('MES')}
                        type="button"
                      >
                        🎉 Este mês é seu aniversário
                      </button>

                      <button
                        className={`type-chip ${isBirthdayTodayMode ? 'active' : ''}`}
                        onClick={() => handleChangeBirthdayMode('HOJE')}
                        type="button"
                      >
                        🎂 Hoje é seu aniversário
                      </button>
                    </div>
                  )}

                  <div className="campaign-grid">
                    <div className="campaign-clients-panel">
                      <div className="filter-bar">
                        <div className="input-group">
                          <label><Icons.Filter /> {campaignFilterLabel}</label>
                          <select className="custom-select" value={campaignMonth} onChange={(e) => setCampaignMonth(e.target.value)}>
                            {gerarOpcoesMeses()}
                          </select>
                        </div>

                        <div className="campaign-audience-hint">{campaignTargetLabel}</div>
                      </div>

                      <div className="clients-list-container">
                        <div className="list-header">
                          <label className="checkbox-container">
                            <input type="checkbox" checked={selectedClients.length === clientsData.length && clientsData.length > 0} onChange={handleToggleAll} />
                            <span className="checkmark"></span>
                          </label>
                          <span className="col-name">Cliente</span>
                          <span className="col-date">{campaignDateColumnLabel}</span>
                        </div>

                        <div className="list-body">
                          {loadingClients ? (
                            <div className="loading-txt">Buscando base de clientes...</div>
                          ) : clientsData.length === 0 ? (
                            <div className="loading-txt">{campaignEmptyStateLabel}</div>
                          ) : (
                            clientsData.map((client) => (
                              <div key={client.id} className="list-row" onClick={() => handleToggleClient(client.id)}>
                                <label className="checkbox-container" onClick={(e) => e.stopPropagation()}>
                                  <input type="checkbox" checked={selectedClients.includes(client.id)} onChange={() => handleToggleClient(client.id)} />
                                  <span className="checkmark"></span>
                                </label>

                                <div className="col-name">
                                  <strong>{client.nome}</strong>
                                  <small>{client.telefone}</small>
                                </div>

                                <span className="col-date">{client.data}</span>
                              </div>
                            ))
                          )}
                        </div>

                        <div className="list-footer">
                          <strong>{selectedClients.length}</strong> clientes selecionados
                        </div>
                      </div>
                    </div>

                    <div className="campaign-editor-panel">
                      <div className="campaign-editor-form">
                        <div className="input-group">
                          <label>
                            {isBirthdayCampaign
                              ? isBirthdayTodayMode
                                ? 'Nome da Campanha de Aniversário de Hoje'
                                : 'Nome da Campanha de Aniversário do Mês'
                              : 'Nome da Campanha (Interno)'}
                          </label>
                          <input
                            type="text"
                            value={campaignForm.titulo}
                            onChange={(e) => setCampaignForm({ ...campaignForm, titulo: e.target.value })}
                            placeholder="Ex: Promoção Dia das Mães"
                          />
                        </div>

                        <div className="image-config-box mt-10">
                          <div className="switch-row compact">
                            <div>
                              <strong>Banner / Imagem</strong>
                              <span>Anexar flyer da campanha</span>
                            </div>
                            <label className="switch">
                              <input type="checkbox" checked={campaignForm.usarImagem} onChange={(e) => setCampaignForm({ ...campaignForm, usarImagem: e.target.checked })} />
                              <span className="slider"></span>
                            </label>
                          </div>

                          {campaignForm.usarImagem && (
                            <div className="upload-area mt-10">
                              <input type="file" accept="image/*" ref={campaignFileInputRef} onChange={handleUploadCampaignImage} style={{ display: 'none' }} />

                              {campaignForm.imagemUrl ? (
                                <div className="uploaded-image-card">
                                  <img src={getFullImageUrl(campaignForm.imagemUrl)} alt="Preview da Campanha" />
                                  <div className="uploaded-image-overlay">
                                    <button className="btn-remove-image" onClick={() => setCampaignForm({ ...campaignForm, imagemUrl: '' })}>
                                      <Icons.Trash /> Remover
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <button className="btn-upload-box" onClick={() => campaignFileInputRef.current.click()} disabled={uploadingCampaignImage}>
                                  {uploadingCampaignImage ? 'Enviando...' : <><Icons.Upload /><span>Selecionar imagem</span></>}
                                </button>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="input-group editor-block mt-10">
                          <div className="textarea-header">
                            <label>
                              {isBirthdayCampaign
                                ? isBirthdayTodayMode
                                  ? 'Mensagem de Aniversário de Hoje'
                                  : 'Mensagem de Aniversário do Mês'
                                : 'Mensagem da Campanha'}
                            </label>
                            <button className="tag-btn" onClick={() => insertTag('camp-msg', campaignForm, setCampaignForm)} type="button">
                              <Icons.Tag /> <strong>{'{{nome}}'}</strong>
                            </button>
                          </div>

                          <textarea
                            id="camp-msg"
                            value={campaignForm.mensagem}
                            onChange={(e) => setCampaignForm({ ...campaignForm, mensagem: e.target.value })}
                            placeholder={
                              !isBirthdayCampaign
                                ? 'Olá {{nome}}, temos uma oferta especial para você...'
                                : isBirthdayTodayMode
                                  ? 'Olá {{nome}}, hoje é o seu dia! Feliz aniversário...'
                                  : 'Olá {{nome}}, este é o mês do seu aniversário...'
                            }
                            style={{ minHeight: '180px' }}
                          />
                        </div>

                        <div className="campaign-actions-dual">
                          <button className="btn-outline" onClick={handleSaveCampaignDraft} disabled={savingCampaignDraft || campaignForm.statusCampanha !== 'RASCUNHO'}>
                            {savingCampaignDraft ? 'Salvando...' : <><Icons.Save /> Salvar Rascunho</>}
                          </button>

                          <button
                            className="btn-send-campaign"
                            onClick={handleSendCampaign}
                            disabled={
                              sendingCampaign ||
                              selectedClients.length === 0 ||
                              campaignForm.statusCampanha === 'CONCLUIDA' ||
                              campaignForm.statusCampanha === 'PROCESSANDO'
                            }
                          >
                            {sendingCampaign
                              ? 'Iniciando...'
                              : (
                                <>
                                  <Icons.Send />
                                  {isBirthdayCampaign
                                    ? isBirthdayTodayMode
                                      ? `Enviar para ${selectedClients.length} aniversariantes de hoje`
                                      : `Enviar para ${selectedClients.length} aniversariantes`
                                    : `Disparar para ${selectedClients.length}`}
                                </>
                              )}
                          </button>
                        </div>
                      </div>

                      <div className="mini-preview-col">
                        {renderPhoneMockup(campaignForm)}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {activeModule === 'base-externa' && (
            <div className="import-workspace module-fade">
              <div className="import-header-row">
                <div>
                  <h3>Base Externa</h3>
                  <p>Importe Excel, CSV ou PDF para alimentar campanhas futuras.</p>
                </div>

                <div className="import-header-actions">
                  <button className="btn-new-secondary" onClick={() => fetchImportedBase()}>
                    <Icons.Refresh /> Atualizar Lista
                  </button>
                  <button className="btn-new-big" onClick={() => importBaseFileInputRef.current?.click()}>
                    <Icons.FileUp /> Importar Arquivo
                  </button>
                  <input
                    type="file"
                    ref={importBaseFileInputRef}
                    style={{ display: 'none' }}
                    accept=".xlsx,.xls,.csv,.pdf"
                    onChange={handleImportBaseFile}
                  />
                </div>
              </div>

              <div className="import-layout">
                <div className="import-left-card">
                  <div className="import-upload-box">
                    <div className="import-upload-illustration">📂</div>
                    <h4>Enviar nova base</h4>
                    <p>Arquivos aceitos: Excel, CSV e PDF.</p>
                    <button className="btn-upload-box" onClick={() => importBaseFileInputRef.current?.click()} disabled={importingBaseFile}>
                      {importingBaseFile ? 'Importando base...' : <><Icons.Upload /><span>Selecionar arquivo</span></>}
                    </button>
                  </div>

                  {lastImportSummary && (
                    <div className="import-summary-card">
                      <div className="summary-title">Última importação</div>
                      <div className="summary-grid">
                        <div><strong>Arquivo</strong><span>{lastImportSummary.arquivo || '-'}</span></div>
                        <div><strong>Tipo</strong><span>{lastImportSummary.tipoArquivo || '-'}</span></div>
                        <div><strong>Lidos</strong><span>{lastImportSummary.totalLidos ?? 0}</span></div>
                        <div><strong>Válidos</strong><span>{lastImportSummary.totalValidos ?? 0}</span></div>
                        <div><strong>Inseridos</strong><span>{lastImportSummary.inseridos ?? 0}</span></div>
                        <div><strong>Atualizados</strong><span>{lastImportSummary.atualizados ?? 0}</span></div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="import-right-card">
                  <div className="import-list-header">
                    <h4>Contatos importados</h4>
                    <span className="import-count">{importedBaseList.length} registros</span>
                  </div>

                  <div className="import-table-wrap">
                    <div className="import-table-head">
                      <span>Nome</span>
                      <span>Telefone</span>
                      <span>Cidade</span>
                      <span>Aniversário</span>
                      <span>Ação</span>
                    </div>

                    <div className="import-table-body">
                      {loadingImportedBase ? (
                        <div className="loading-txt">Carregando base externa...</div>
                      ) : importedBaseList.length === 0 ? (
                        <div className="empty-state">
                          <div className="empty-illustration">🗂️</div>
                          <p>Nenhuma base importada ainda.</p>
                        </div>
                      ) : (
                        importedBaseList.map((item) => (
                          <div key={item._id} className="import-row">
                            <div className="import-col import-col-name">
                              <strong>{item.nome || 'Sem nome'}</strong>
                              <small>{item.bairro || '-'}</small>
                            </div>
                            <div className="import-col">{item.telefone || '-'}</div>
                            <div className="import-col">{item.cidade || '-'}</div>
                            <div className="import-col">
                              {item.dataNascimento
                                ? new Date(item.dataNascimento).toLocaleDateString('pt-BR')
                                : '-'}
                            </div>
                            <div className="import-col actions">
                              <button className="btn-remove-line" onClick={() => handleRemoveImportedContact(item._id)}>
                                <Icons.Trash />
                              </button>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {mobileMenuOpen && <div className="mobile-backdrop" onClick={() => setMobileMenuOpen(false)}></div>}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        :root {
          --cms-border: #e2e8f0;
          --navy: #0f172a;
          --blue: #4f46e5;
          --emerald: #10b981;
        }

        * { box-sizing: border-box; }
        .cms-container { background: #fff; border-radius: 24px; border: 1px solid var(--cms-border); display: flex; flex-direction: column; font-family: 'Plus Jakarta Sans', sans-serif; height: 100%; min-height: 760px; overflow: hidden; }
        .cms-header { padding: 20px 28px; border-bottom: 1px solid var(--cms-border); display: flex; justify-content: space-between; align-items: center; }
        .brand-badge { font-size: 10px; font-weight: 800; color: var(--blue); background: #EEF2FF; padding: 4px 8px; border-radius: 6px; margin-bottom: 4px; display: inline-block; }
        .header-info h2 { font-size: 20px; font-weight: 800; color: var(--navy); margin: 0; }
        .notify-pill { font-size: 13px; font-weight: 700; padding: 8px 16px; border-radius: 20px; display: flex; align-items: center; gap: 8px; }
        .notify-pill.success { background: #dcfce7; color: #166534; }
        .notify-pill.error { background: #fee2e2; color: #991b1b; }

        .cms-body { display: flex; flex: 1; overflow: hidden; }
        .main-nav { width: 260px; min-width: 260px; background: #f8fafc; border-right: 1px solid var(--cms-border); padding: 24px 16px; display: flex; flex-direction: column; gap: 24px; }
        .nav-group { display: flex; flex-direction: column; gap: 8px; }
        .nav-label { font-size: 11px; font-weight: 800; color: #94a3b8; text-transform: uppercase; padding-left: 12px; }
        .nav-item { display: flex; align-items: center; gap: 12px; width: 100%; padding: 12px 14px; border-radius: 12px; background: transparent; border: none; color: #475569; font-size: 14px; font-weight: 600; cursor: pointer; text-align: left; }
        .nav-item:hover { background: #e2e8f0; color: var(--navy); }
        .nav-item.active { background: var(--blue); color: #fff; }
        .badge-new { background: #10b981; color: #fff; font-size: 10px; padding: 2px 6px; border-radius: 4px; margin-left: auto; }

        .cms-workspace { flex: 1; overflow: hidden; }
        .workspace-grid-with-sidebar { display: grid; grid-template-columns: 280px 1fr; height: 100%; }
        .workspace-content-split { display: grid; grid-template-columns: 1fr 380px; height: 100%; }
        .secondary-sidebar { border-right: 1px solid var(--cms-border); display: flex; flex-direction: column; background: #fafafa; }
        .sidebar-header-row { display: flex; justify-content: space-between; padding: 20px 16px 10px; }
        .sidebar-title { font-size: 11px; font-weight: 800; color: #94a3b8; }
        .btn-new-mini, .btn-back, .btn-outline, .btn-new-secondary, .btn-new-big, .btn-remove-line { cursor: pointer; }
        .btn-new-mini { background: #fff; border: 1px solid var(--cms-border); color: var(--blue); padding: 6px 12px; border-radius: 8px; font-size: 11px; font-weight: 700; display: flex; align-items: center; gap: 4px; }
        .template-list { overflow-y: auto; padding: 12px; flex: 1; }
        .template-item { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 10px; cursor: pointer; margin-bottom: 6px; border: 1px solid transparent; }
        .template-item:hover { background: #fff; border-color: #e2e8f0; }
        .template-item.active { background: #fff; border-color: #cbd5e1; }
        .item-icon { width: 32px; height: 32px; background: #e2e8f0; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
        .template-item.active .item-icon { background: var(--blue); color: #fff; }
        .item-content { display: flex; flex-direction: column; }
        .item-marco { font-size: 13px; font-weight: 800; color: var(--navy); }
        .item-title { font-size: 12px; color: #64748b; }

        .editor-panel { padding: 32px; overflow-y: auto; }
        .editor-form { display: flex; flex-direction: column; gap: 20px; max-width: 800px; margin: 0 auto; height: 100%; }
        .editor-form h3 { margin: 0; font-size: 18px; color: var(--navy); }
        .max-w-700 { max-width: 700px; }
        .module-header p { margin: 4px 0 0; color: #64748b; font-size: 14px; }

        .form-row { display: flex; gap: 16px; }
        .flex-1 { flex: 1; }
        .w-120 { width: 140px; }
        .input-group label { display: block; font-size: 12px; font-weight: 700; color: #64748b; margin-bottom: 8px; text-transform: uppercase; }
        .input-group input, .custom-select { width: 100%; padding: 12px 16px; border: 1px solid var(--cms-border); border-radius: 12px; font-size: 14px; font-weight: 600; outline: none; background: #fcfcfc; }
        .locked-badge { padding: 12px; background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 12px; color: #64748b; font-weight: 700; text-align: center; }

        .image-config-box { background: #f8fafc; border: 1px solid #e2e8f0; padding: 16px; border-radius: 14px; }
        .switch-row { display: flex; justify-content: space-between; align-items: center; }
        .switch-row strong { display: block; font-size: 14px; color: var(--navy); }
        .switch-row span { font-size: 12px; color: #64748b; }
        .switch { position: relative; width: 44px; height: 24px; }
        .switch input { opacity: 0; width: 0; height: 0; }
        .slider { position: absolute; inset: 0; background: #cbd5e1; border-radius: 34px; cursor: pointer; transition: .2s; }
        .slider:before { content: ""; position: absolute; height: 18px; width: 18px; left: 3px; bottom: 3px; background: white; border-radius: 50%; transition: .2s; }
        .switch input:checked + .slider { background: var(--blue); }
        .switch input:checked + .slider:before { transform: translateX(20px); }
        .mt-10 { margin-top: 10px; }
        .mt-20 { margin-top: 20px; }

        .btn-upload-box { width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 24px; border: 2px dashed #cbd5e1; border-radius: 12px; background: #fff; color: #64748b; font-size: 13px; font-weight: 600; }
        .uploaded-image-card { position: relative; width: 100%; height: 200px; border-radius: 12px; overflow: hidden; border: 1px solid var(--cms-border); }
        .uploaded-image-card img { width: 100%; height: 100%; object-fit: cover; }
        .uploaded-image-overlay { position: absolute; inset: 0; background: rgba(15,23,42,0.6); display: flex; align-items: center; justify-content: center; opacity: 0; transition: 0.2s; }
        .uploaded-image-card:hover .uploaded-image-overlay { opacity: 1; }
        .btn-remove-image { background: #ef4444; color: #fff; border: none; padding: 8px 16px; border-radius: 8px; font-size: 13px; font-weight: 700; display: flex; align-items: center; gap: 6px; }

        .textarea-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
        .tag-btn { background: #EEF2FF; color: var(--blue); border: 1px solid #c7d2fe; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; display: flex; align-items: center; gap: 4px; }
        textarea { width: 100%; flex: 1; min-height: 200px; padding: 16px; border: 1px solid var(--cms-border); border-radius: 14px; font-family: inherit; resize: none; outline: none; line-height: 1.5; }

        .editor-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; }
        .btn-save { background: var(--navy); color: #fff; border: none; padding: 12px 24px; border-radius: 12px; font-weight: 700; display: flex; gap: 8px; align-items: center; }

        .preview-panel { background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%); border-left: 1px solid var(--cms-border); display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px; overflow-y: auto; }
        .preview-title-row { width: 100%; max-width: 300px; display: flex; justify-content: space-between; margin-bottom: 12px; }
        .preview-kicker { font-size: 10px; font-weight: 800; color: #64748b; }
        .preview-badge { background: #eef2ff; color: var(--blue); padding: 4px 8px; border-radius: 10px; font-size: 10px; font-weight: 700; }
        .phone-mockup { width: 300px; height: 580px; background: #fff; border-radius: 36px; border: 8px solid #1e293b; position: relative; display: flex; flex-direction: column; overflow: hidden; }
        .phone-notch { position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 100px; height: 20px; background: #1e293b; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; z-index: 10; }
        .phone-header { background: #075e54; padding: 30px 16px 12px; display: flex; align-items: center; gap: 10px; color: #fff; }
        .ph-avatar { width: 32px; height: 32px; background: #fff; border-radius: 50%; color: #075e54; display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 800; }
        .ph-name { font-size: 14px; font-weight: 700; display: block; }
        .ph-status { font-size: 10px; opacity: 0.8; }
        .phone-body { flex: 1; background: #e5ddd5; padding: 16px; overflow-y: auto; }
        .msg-bubble { background: #dcf8c6; padding: 8px 10px; border-radius: 8px; border-top-left-radius: 0; font-size: 13px; color: #111b21; max-width: 95%; word-wrap: break-word; }
        .msg-image-preview { margin-bottom: 8px; border-radius: 6px; overflow: hidden; }
        .msg-image-preview img { width: 100%; max-height: 150px; object-fit: cover; display: block; }
        .var-highlight { color: #4F46E5; font-weight: 700; background: rgba(79,70,229,0.1); padding: 0 2px; border-radius: 4px; }
        .msg-meta { display: flex; justify-content: flex-end; gap: 4px; margin-top: 4px; opacity: 0.6; align-items: center; }
        .msg-time { font-size: 10px; }
        .phone-footer { background: #f0f2f5; padding: 10px; display: flex; gap: 8px; }
        .ph-input { flex: 1; background: #fff; border-radius: 20px; padding: 0 12px; display: flex; align-items: center; font-size: 12px; color: #999; }
        .ph-mic { width: 32px; height: 32px; background: #008f72; border-radius: 50%; color: #fff; display: flex; align-items: center; justify-content: center; }

        .campaign-workspace, .import-workspace { display: flex; flex-direction: column; height: 100%; overflow: hidden; }
        .campaign-list-view, .import-workspace { padding: 32px; overflow-y: auto; height: 100%; background: #f8fafc; }
        .campaign-header-row, .import-header-row { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 32px; gap: 16px; }
        .campaign-header-row h3, .import-header-row h3 { margin: 0 0 4px; font-size: 24px; color: var(--navy); }
        .campaign-header-row p, .import-header-row p { margin: 0; color: #64748b; font-size: 14px; }
        .campaign-header-actions, .import-header-actions { display: flex; gap: 12px; flex-wrap: wrap; justify-content: flex-end; }
        .btn-new-big { background: var(--blue); color: white; border: none; padding: 12px 24px; border-radius: 12px; font-weight: 700; display: flex; align-items: center; gap: 8px; }
        .btn-new-secondary { background: #fff; color: var(--navy); border: 1px solid #cbd5e1; padding: 12px 18px; border-radius: 12px; font-weight: 700; display: flex; align-items: center; gap: 8px; }

        .campaigns-grid-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 20px; }
        .campaign-card { background: #fff; border: 1px solid var(--cms-border); padding: 20px; border-radius: 16px; cursor: pointer; }
        .camp-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
        .status-badge { font-size: 10px; font-weight: 800; padding: 4px 8px; border-radius: 6px; text-transform: uppercase; }
        .status-badge.rascunho { background: #f1f5f9; color: #64748b; border: 1px solid #e2e8f0; }
        .status-badge.processando { background: #fef08a; color: #854d0e; }
        .status-badge.concluida { background: #dcfce7; color: #166534; }
        .status-badge.inline { display: inline-block; margin-left: 12px; vertical-align: middle; }
        .camp-date { font-size: 12px; color: #94a3b8; font-weight: 600; }
        .campaign-card-type { display: inline-flex; margin-bottom: 10px; font-size: 11px; font-weight: 800; color: #7c3aed; background: #f5f3ff; padding: 4px 8px; border-radius: 999px; }
        .campaign-card h4 { margin: 0 0 16px; font-size: 16px; color: var(--navy); }
        .camp-stats { display: flex; gap: 16px; border-top: 1px solid #f1f5f9; padding-top: 12px; font-size: 13px; color: #64748b; }
        .camp-stats strong { color: var(--navy); font-size: 14px; }

        .campaign-header { display: flex; align-items: center; gap: 16px; padding: 20px 32px; border-bottom: 1px solid var(--cms-border); background: #fff; }
        .btn-back { background: transparent; border: 1px solid var(--cms-border); padding: 8px 12px; border-radius: 8px; display: flex; align-items: center; gap: 6px; font-weight: 600; color: #475569; }
        .campaign-header h3 { margin: 0; font-size: 18px; color: var(--navy); }
        .campaign-type-strip, .birthday-mode-strip { display: flex; gap: 12px; padding: 16px 32px; border-bottom: 1px solid var(--cms-border); background: #f8fafc; flex-wrap: wrap; }
        .type-chip { border: 1px solid #cbd5e1; background: #fff; color: #475569; padding: 10px 16px; border-radius: 999px; font-size: 13px; font-weight: 700; cursor: pointer; }
        .type-chip.active { background: #eef2ff; color: var(--blue); border-color: #c7d2fe; }

        .campaign-grid { display: grid; grid-template-columns: 380px 1fr; flex: 1; overflow: hidden; }
        .campaign-clients-panel { border-right: 1px solid var(--cms-border); background: #fafafa; display: flex; flex-direction: column; overflow: hidden; }
        .filter-bar { padding: 16px; border-bottom: 1px solid var(--cms-border); background: #fff; }
        .campaign-audience-hint { margin-top: 10px; font-size: 12px; font-weight: 700; color: var(--blue); background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 10px; padding: 8px 10px; }

        .clients-list-container { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
        .list-header { display: flex; align-items: center; padding: 12px 16px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; font-size: 12px; font-weight: 700; color: #64748b; gap: 12px; }
        .list-body { flex: 1; overflow-y: auto; background: #fff; }
        .list-row { display: flex; align-items: center; padding: 14px 16px; border-bottom: 1px solid #f1f5f9; cursor: pointer; gap: 12px; }
        .col-name { flex: 1; display: flex; flex-direction: column; min-width: 0; }
        .col-name strong { font-size: 13px; color: var(--navy); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .col-name small { font-size: 11px; color: #94a3b8; }
        .col-date { font-size: 12px; color: #64748b; white-space: nowrap; }
        .list-footer { padding: 12px 16px; background: #eef2ff; color: var(--blue); font-size: 12px; text-align: center; border-top: 1px solid #c7d2fe; }

        .checkbox-container { display: block; position: relative; padding-left: 20px; }
        .checkbox-container input { position: absolute; opacity: 0; }
        .checkmark { position: absolute; top: -10px; left: 0; height: 18px; width: 18px; background-color: #fff; border: 2px solid #cbd5e1; border-radius: 4px; }
        .checkbox-container input:checked ~ .checkmark { background-color: var(--blue); border-color: var(--blue); }
        .checkmark:after { content: ""; position: absolute; display: none; left: 5px; top: 1px; width: 4px; height: 9px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); }
        .checkbox-container input:checked ~ .checkmark:after { display: block; }

        .campaign-editor-panel { display: grid; grid-template-columns: 1fr 340px; height: 100%; overflow: hidden; }
        .campaign-editor-form { padding: 32px; overflow-y: auto; display: flex; flex-direction: column; gap: 20px; }
        .campaign-actions-dual { margin-top: auto; padding-top: 20px; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .btn-outline { background: #fff; color: var(--navy); border: 1px solid var(--cms-border); padding: 14px; border-radius: 12px; font-size: 14px; font-weight: 700; display: flex; justify-content: center; align-items: center; gap: 8px; }
        .btn-send-campaign { background: var(--emerald); color: #fff; border: none; padding: 14px; border-radius: 12px; font-size: 14px; font-weight: 700; display: flex; justify-content: center; align-items: center; gap: 8px; }

        .mini-preview-col { background: #f8fafc; border-left: 1px solid var(--cms-border); padding: 24px; display: flex; align-items: center; justify-content: center; overflow-y: auto; }

        .import-layout { display: grid; grid-template-columns: 360px 1fr; gap: 20px; min-height: 520px; }
        .import-left-card, .import-right-card { background: #fff; border: 1px solid var(--cms-border); border-radius: 18px; padding: 20px; }
        .import-upload-box { border: 2px dashed #cbd5e1; border-radius: 16px; padding: 24px; text-align: center; background: #fafcff; }
        .import-upload-illustration { font-size: 34px; margin-bottom: 10px; }
        .import-upload-box h4, .import-list-header h4 { margin: 0 0 6px; color: var(--navy); }
        .import-upload-box p { margin: 0 0 18px; color: #64748b; font-size: 13px; }
        .import-summary-card { margin-top: 18px; background: #f8fafc; border: 1px solid var(--cms-border); border-radius: 14px; padding: 16px; }
        .summary-title { font-size: 13px; font-weight: 800; color: var(--navy); margin-bottom: 12px; }
        .summary-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
        .summary-grid div { background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 10px; display: flex; flex-direction: column; }
        .summary-grid strong { font-size: 11px; color: #64748b; text-transform: uppercase; margin-bottom: 4px; }
        .summary-grid span { font-size: 13px; color: var(--navy); font-weight: 700; }
        .import-list-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
        .import-count { background: #eef2ff; color: var(--blue); padding: 6px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; }
        .import-table-wrap { border: 1px solid var(--cms-border); border-radius: 14px; overflow: hidden; }
        .import-table-head, .import-row { display: grid; grid-template-columns: 2fr 1.2fr 1fr 1fr 80px; gap: 12px; align-items: center; padding: 14px 16px; }
        .import-table-head { background: #f8fafc; border-bottom: 1px solid var(--cms-border); font-size: 12px; font-weight: 800; color: #64748b; text-transform: uppercase; }
        .import-table-body { max-height: 480px; overflow-y: auto; background: #fff; }
        .import-row { border-bottom: 1px solid #f1f5f9; }
        .import-col { font-size: 13px; color: var(--navy); }
        .import-col-name { display: flex; flex-direction: column; min-width: 0; }
        .import-col-name strong { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .import-col-name small { color: #94a3b8; font-size: 11px; }
        .import-col.actions { display: flex; justify-content: center; }
        .btn-remove-line { width: 34px; height: 34px; border-radius: 10px; border: 1px solid #fecaca; background: #fff5f5; color: #dc2626; display: flex; align-items: center; justify-content: center; }

        .loading-txt { padding: 20px; text-align: center; color: #64748b; font-size: 13px; }
        .empty-state { padding: 32px; text-align: center; color: #64748b; }
        .empty-illustration { font-size: 36px; margin-bottom: 10px; }
        .btn-icon.mobile-only { display: none; background: #fff; border: 1px solid var(--cms-border); padding: 8px; border-radius: 8px; }

        @media (max-width: 1200px) {
          .campaign-grid { grid-template-columns: 300px 1fr; }
          .campaign-editor-panel { grid-template-columns: 1fr; }
          .mini-preview-col { display: none; }
          .import-layout { grid-template-columns: 1fr; }
        }

        @media (max-width: 900px) {
          .workspace-grid-with-sidebar { grid-template-columns: 240px 1fr; }
          .workspace-content-split { grid-template-columns: 1fr; }
          .preview-panel { display: none; }
          .btn-icon.mobile-only { display: block; }
          .main-nav { position: fixed; left: -100%; top: 0; height: 100vh; transition: 0.3s; z-index: 100; box-shadow: 10px 0 30px rgba(0,0,0,0.1); }
          .main-nav.open { left: 0; }
          .mobile-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 90; }
          .campaign-grid { grid-template-columns: 1fr; grid-template-rows: 350px 1fr; }
          .campaign-clients-panel { border-right: none; border-bottom: 1px solid var(--cms-border); }
          .import-table-head, .import-row { grid-template-columns: 1.6fr 1fr 1fr 1fr 60px; }
        }

        @media (max-width: 600px) {
          .cms-container { border-radius: 0; border: none; min-height: 100vh; }
          .workspace-grid-with-sidebar { grid-template-columns: 1fr; }
          .secondary-sidebar { height: 250px; border-right: none; border-bottom: 1px solid var(--cms-border); }
          .editor-panel, .campaign-editor-form, .campaign-list-view, .import-workspace { padding: 16px; }
          .form-row { flex-direction: column; }
          .w-120 { width: 100%; }
          .campaign-actions-dual { grid-template-columns: 1fr; }
          .campaign-header-actions, .import-header-actions { width: 100%; }
          .import-table-head { display: none; }
          .import-row { grid-template-columns: 1fr; gap: 8px; }
          .import-col.actions { justify-content: flex-start; }
        }
      `}</style>
    </div>
  );
}